<template>
  <div class="sticky-offers" v-if="offersActiveSticky.length">
    <q-carousel
        v-model="slide"
        transition-prev="scale"
        transition-next="scale"
        swipeable
        animated
        control-color="black"
        arrows
        class="c-carousel bg-transparent"
        :height="carouselHeight"
        :autoplay1="10000"
        infinite
    >
      <q-carousel-slide
          v-for="offer in offersActiveSticky"
          :name="offer.ID"
          :key="offer.ID"
          class="column no-wrap flex-center q-pa-none"
      >
        <StickyOffer :offer="offer"/>
      </q-carousel-slide>
    </q-carousel>
  </div>
</template>

<script setup lang="ts">
import {computed, ref, watch} from "vue";
import {storeToRefs} from "pinia";
import {useOfferStore} from "@/modules/offer/store/offer";
import StickyOffer from "@/components/Offer/StickyOffer.vue";
import {useQuasar} from "quasar";

const $q = useQuasar();

const offerStore = useOfferStore()
const {offersActiveSticky} = storeToRefs(offerStore);

const slide = ref();

const carouselHeight = computed(() => $q.screen.lt.md ? '44px' : '54px');

watch(offersActiveSticky, () => {
  slide.value = offersActiveSticky.value[0]?.ID;
}, {immediate: true})

</script>

<style lang="scss" scoped>

.sticky-offers {
  .q-carousel {
    height: auto !important;
  }
}

.c-carousel {
  overflow: visible !important;

  @media (max-width: $breakpoint-sm-max) {
    overflow: hidden !important;
  }

  :deep(.q-panel) {
    overflow: visible !important;

    @media (max-width: $breakpoint-sm-max) {
      overflow: hidden !important;
    }
  }

  :deep(.q-carousel__control) {
    display: none;

    button {
      min-height: auto;
      min-width: auto;
    }
  }

  :deep(.q-carousel__prev-arrow) {
    left: -40px;
  }

  :deep(.q-carousel__next-arrow) {
    right: -40px;
  }
}

</style>
